<template>
  <div class="container">
    <custom-select
      label="Sexo según documento"
      :value="value"
      :name="name"
      @click="$emit('click')"
      @onFocus="$emit('onFocus')"
      @input="onChange"
      :items="tipoSexo"
      :required="required"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import CustomSelect from "@/__tests-ab__/AR2024CNOMV2/components/core/custom/CustomSelect";
export default {
  name: "SexoSelect",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    required: Boolean,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tipoSexoItems: {
        "": "",
        Femenino: "F",
        Masculino: "M"
      }
    };
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    tipoSexo() {
      return Object.keys(this.tipoSexoItems).map(item => {
        return {
          label: item,
          value: this.tipoSexoItems[item]
        };
      });
    }
  }
};
</script>
